export default "<div *ngIf=\"conflict\" class=\"leva-width-common-main\">\n    <em class=\"ld-icon-information ld-red\"></em>\n</div>\n"